import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
  Input,
  Select,
  Switch,
  Modal,
  Spin,
  notification,
} from "antd";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { encryptAES } from "../../../redux/middleware/encryptPayloadUtils";
import useApiInterceptor from "../../../hooks/useInterceptor";
import { clearConfig } from "dompurify";
import { rolesRoutes } from "../../../config/rolesConfig";
import { fetchLocationData } from "../../Location/api/useGetlocation";
import UserTable from "./UserTable";
import PermissionModal from "./PermissionModal";
import { create } from "lodash";
import { openNotification } from "../../Auth/utils/Notification";
import { endLoading, startLoading } from "../../../redux/slices/loadingSlice";

const Settings = () => {
  const apiInterceptor = useApiInterceptor();
 const dispatch = useDispatch()
  const accessToken = useSelector(
    (state) => state.auth.authData[0].accessToken
  );
  const currentUserData = useSelector((state) => state.user.userData[0]);
  const curentPlantData = useSelector((state) => state.plant.plantData[0]);
  const currentLocationData = useSelector(
    (state) => state.location.locationData[0]
  );

  const [loading, setLoading] = useState({
    createUser: false,
    fetchUser: false,
  });
  const [modal2Open, setModal2Open] = useState(false);
  const [plants, setPlants] = useState([]);
  const [locations, setLocation] = useState([]);
  const [userData, setUserData] = useState([]);

  const fetchUserData = async (selectedLocation, userID = false) => {
    try {
      setLoading((prev) => ({ ...prev, fetchUser: true }));
      const encryptedLocationId = encryptAES(JSON.stringify(selectedLocation));
      const url = userID
        ? `/user/?plant=${encryptedLocationId}`
        : `/user/?location=${encryptedLocationId}`;
      const res = await apiInterceptor.get(url);
      if (res.data.results && res.status === 200) {
        setLoading((prev) => ({ ...prev, fetchUser: false }));
        setUserData(res.data.results);
      }
    } catch (error) {
      console.log(error);
      setLoading((prev) => ({ ...prev, fetchUser: false }));
    }
  };

  const fetchPlantData = async (selectedLocation) => {
    try {
      if (!accessToken) {
        return;
      }
      const ecncryptedLocationId = encryptAES(JSON.stringify(selectedLocation));
      const res = await apiInterceptor.get(
        `/plant/?location_id=${ecncryptedLocationId}`
      );
      const { results } = res.data;

      if (results) {
        setPlants(results);
      } else {
        console.warn("No results found in the response");
      }
    } catch (err) {
      console.log("Error fetching plant data:");
      if (err.response && err.response.data.code === "token_not_valid") {
        console.log("Token is invalid or expired.");
      } else {
        console.log("Error:", err.message || "Unknown log occurred");
      }
    }
  };

  const handleGetUserData = () => {
    if (currentUserData.roleName === "Manager") {
      fetchPlantData(currentUserData.locationId);
      fetchUserData(currentUserData.locationId);
    }
    if (currentUserData.roleName === "General Manager") {
      fetchUserData(currentLocationData.id);
    }
    if (currentUserData.roleName === "User") {
      fetchUserData(curentPlantData.id, true);
    }
  };

  useEffect(() => {
   
    fetchLocationData(accessToken, apiInterceptor)
      .then((results) => {
        if (results && Array.isArray(results)) {
          setLocation(results);
        } else {
          console.log("No location data found.");
        }
      })
      .catch((err) => {
        console.log("Error in fetching location data:", err);
      });
    handleGetUserData();
  }, []);

  const headersOb = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    employee_id: "",
    plant: null, //pass id
    role: null, // pass id
  });
  const [error, setError] = useState({
    fistName: "",
    lastName: "",
    Phone: "",
    email: "",
    employee_id: "",
    plant: "",
    location: "",
    role: "",
  });

  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedPlant, setSelectedPlant] = useState(null);

  const handleRoleChange = (value) => {
    setError((prev) => ({ ...prev, role: "" }));
    setSelectedRole(value);
    setSelectedLocation(null);
  };

  const handleLocationChange = (value) => {
    setSelectedPlant(null);
    setSelectedLocation(value);
    fetchPlantData(value);
    setError((prev) => ({ ...prev, location: "" }));
  };

  const closeModalUser = () => {
    setModal2Open(false);
    setData({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      employee_id: "",
      plant: null,
      role_name: null,
    });
    setError({
      fistName: "",
      lastName: "",
      Phone: "",
      email: "",
      employee_id: "",
      plant: null,
      role_name: null,
    });
    setSelectedLocation(null);
    setSelectedRole(null);
    setSelectedPlant(null);
  };

  const handlePost = async () => {
    try {
      const emailPattern = /^[a-zA-Z\d._%+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

      const validateRequired = (field, fieldName) => {
        return !field ? `*Please Enter ${fieldName}` : null;
      };

      const validatePhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return "*Please Enter Phone Number";

        const phoneRegex = /^[6-9]\d{9}$/; // Regex to validate Indian mobile numbers starting with 6-9 and 10 digits long
        return !phoneRegex.test(phoneNumber)
          ? "*Please Enter Valid Phone Number"
          : null;
      };

      const validateEmail = (email) => {
        if (!email) return "*Please Enter Email";
        return !emailPattern.test(email) ? "*Please Enter Valid Email" : null;
      };

      let errors = {};

      // Validate fields
      errors.firstName = validateRequired(data.first_name, "First Name");
      errors.lastName = validateRequired(data.last_name, "Last Name");
      errors.Phone = validatePhoneNumber(data.phone_number);
      errors.email = validateEmail(data.email);
      errors.employee_id = validateRequired(data.employee_id, "Employee ID");

      errors.role = validateRequired(selectedRole, "Role");

      // LOGGED USER GM , REQUIRED ,

      if (currentUserData.roleName === "General Manager") {
        errors.location = validateRequired(selectedLocation, "Location");
      } else if (
        currentUserData.roleName === "Manager" &&
        selectedRole === "User"
      ) {
        error.location = "";
        setError((prev) => ({ ...prev, location: "" }));
      }

      if (
        currentUserData.roleName === "General Manager" &&
        selectedRole === "Manager"
      ) {
        setError((prev) => ({ ...prev, Plant: "" }));
      } else if (selectedRole === "Manager") {
        setError((prev) => ({ ...prev, Plant: "" }));
      } else {
        errors.plant = validateRequired(selectedPlant, "Plant");
      }

      errors = Object.fromEntries(
        Object.entries(errors).filter(([_, v]) => v !== null)
      );
      setError(errors); // Update errors

      if (Object.keys(errors).length > 0) {
        dispatch(endLoading())
        setLoading((prev) => ({ ...prev, createUser: false }));
        return;
      }

      // Create payload
      const payload = {
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        email: data.email,
        employee_id: data.employee_id.toUpperCase(),
        plant: selectedPlant,
        role:
          selectedRole === "Manager" ? 2 : selectedRole === "user" ? 3 : null,
        location:
          currentUserData.roleName === "Manager"
            ? currentUserData.locationId
            : selectedLocation,
        password: null,
      };

      // Encrypt the payload
      const encryptedData = await encryptAES(JSON.stringify(payload));
      const usersPayload = {
        data: encryptedData,
      };
      // Set loading state and make the API request
      dispatch(startLoading())
      setLoading((prev) => ({ ...prev, createUser: true }));
      const postRequest = await apiInterceptor.post(
        `user/`,
        usersPayload,
        headersOb
      );

      // On successful request, handle success
      if (postRequest) {
        closeModalUser();
        setModal2Open(false);
        setLoading(false);
        dispatch(endLoading())
        resetForm();
        handleGetUserData();

        openNotification("success", "User Created Successfully!");
      }
    } catch (error) {
      // Handle error response
      setLoading((prev) => ({ ...prev, createUser: false }));
      dispatch(endLoading())

      if (error?.response?.message === "Token is invalid or expired") {
        openNotification("error", "Unable to create user, Please Try again!");
      } else {
        openNotification("error", error?.response?.data?.message);
      }
    }
  };

  // Reset form function to clear form data and errors
  const resetForm = () => {
    setData({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      employee_id: "",
      plant: null,
      role: null,
    });
    setLoading((prev) => ({ ...prev, createUser: false }));
    dispatch(endLoading())
    setError({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const emailRegex = /^[^\s@]+@[^\s@]+\[^\s@]+$/;

    if (name === "first_name") {
      setError((prev) => ({ ...prev, firstName: "" }));
    }
    if (name === "last_name") {
      setError((prev) => ({ ...prev, lastName: "" }));
    }
    if (name === "phone_number") {
      setError((prev) => ({ ...prev, Phone: "" }));
    }
    if (name === "employee_id") {
      setError((prev) => ({ ...prev, employee_id: "" }));
    }
    if (name === "email") {
      if (emailRegex.test(data.email)) {
        setError((prev) => ({ ...prev, email: "Enter Valid Email" }));
      } else {
        setError((prev) => ({ ...prev, email: "" }));
      }
    }
    setData((prev) => ({ ...prev, [name]: value.replace(/\s/g, "") }));
  };

  const handlePlantChange = (value) => {
    setError((prev) => ({ ...prev, plant: "" }));
    setSelectedPlant(value);
  };


  return (
    <>
    <div className="relative p-2">
      <Row
        gutter={24}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Col span={9}>
          {/* <h5 style={{ fontWeight: 650 }}>User Creation</h5> */}
        </Col>
        <Col span={3}>
          {currentUserData.roleName !== "User" && (
            <Button
              className="commButton"
              type="primary"
              style={{ width: "100%", padding: "0" }}
              danger
              onClick={() => setModal2Open(true)}
            >
              User Creation
            </Button>
          )}
        </Col>
      </Row>
      <Row
        gutter={24}
        className="bg-white p-3 rounded-md shadow-lg "
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          margin: "2rem",
        }}
      >
        {loading.fetchUser ? (
          <Spin size="large" />
        ) : (
          <UserTable
            userData={userData}
            handleGetUserData={handleGetUserData}
          />
        )}
 
      </Row>

    </div>

      <Row
        style={{
          display: "flex",
          gap: "2rem",
          flexDirection: "column",
          marginTop: "1rem",
        }}
      >
        <Col
          style={{ display: "flex", alignItems: "center", gap: "1rem" }}
          span={8}
        >
          <h5 style={{ fontWeight: 650, marginBottom: 0, minWidth: "200px" }}>
            Send email notification
          </h5>
          <Switch defaultChecked />
        </Col>
        <Col
          style={{ display: "flex", alignItems: "center", gap: "1rem" }}
          span={8}
        >
          <h5 style={{ fontWeight: 650, marginBottom: 0, minWidth: "200px" }}>
            Send sms notification
          </h5>
          <Switch defaultChecked />
        </Col>
      </Row>
      <Modal
        title={
          <div style={{ textAlign: "center", fontSize: "1.3rem" }}>
            Create User
          </div>
        }
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={closeModalUser}
        footer={null}
        maskClosable={false} // This prevents the modal from closing on outside clicks
      >
          <>
            <div
              className=""
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                padding: "1rem",
                fontWeight: "600",
              }}
            >
              <div className="">
                <Input
                  autoComplete="off"
                  placeholder="*Enter First Name"
                  type="text"
                  name="first_name"
                  value={data.first_name}
                  onChange={handleChange}
                  helper
                  className="p-2 custom-input"
                />
                {error.firstName ? (
                  <span style={{ fontWeight: "600", color: "red" }}>
                    {error.firstName}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="">
                <Input
                  autoComplete="off"
                  placeholder="*Enter Last Name"
                  type="text"
                  name="last_name"
                  value={data.last_name}
                  onChange={handleChange}
                  className="p-2 custom-input"
                />
                {error.lastName ? (
                  <span style={{ fontWeight: "600", color: "red" }}>
                    {error.lastName}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="">
                <Input
                  autoComplete="off"
                  placeholder="*Enter Phone Number"
                  type="number"
                  name="phone_number"
                  value={data.phone_number}
                  onChange={handleChange}
                  className="p-2 custom-input"
                />
                {error.Phone ? (
                  <span style={{ fontWeight: "600", color: "red" }}>
                    {error.Phone}
                  </span>
                ) : (
                  ""
                )}
              </div>

              <div className="">
                <Input
                  autoComplete="off"
                  placeholder="*Enter Email"
                  type="text"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  className="p-2 custom-input"
                />
                {error.email ? (
                  <span style={{ fontWeight: "600", color: "red" }}>
                    {error.email}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="">
                <Input
                  autoComplete="off"
                  placeholder="*Enter Employee Id"
                  type="text"
                  name="employee_id"
                  value={(data.employee_id || "").toString().toUpperCase()}
yy                  onChange={handleChange}
                  className="p-2 custom-input"
                />
                {error.employee_id ? (
                  <span style={{ fontWeight: "600", color: "red" }}>
                    {error.employee_id}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <>
                <div style={{ marginBottom: error.location ? 0 : 0 }}>
                  <Select
                    size="large"
                    style={{ minWidth: "100%" }}
                    placeholder="Select Role*"
                    value={selectedRole}
                    onChange={handleRoleChange}
                  >
                    {currentUserData.roleName === "General Manager" ? (
                      <>
                        <Select.Option value="Manager">Manager</Select.Option>
                        <Select.Option value="user">User</Select.Option>
                      </>
                    ) : currentUserData.roleName === "Manager" ? (
                      <Select.Option value="user">User</Select.Option>
                    ) : null}
                  </Select>
                  {error.role && (
                    <span style={{ fontWeight: "600", color: "red" }}>
                      {error.role}
                    </span>
                  )}
                </div>
              </>

              {/* Location: show only for General Manager when selectedRole is "Manager" or "user" */}
              {currentUserData.roleName === "General Manager" &&
                (selectedRole === "Manager" || selectedRole === "user") && (
                  <>
                    <div style={{ marginBottom: error.location ? 0 : 0 }}>
                      <Select
                        size="large"
                        style={{ minWidth: "100%" }}
                        placeholder="Select Location*"
                        onChange={handleLocationChange}
                        value={selectedLocation}
                      >
                        {locations.map(({ id, name }) => (
                          <Select.Option key={id} value={id}>
                            {name}
                          </Select.Option>
                        ))}
                      </Select>
                      {error.location && (
                        <span style={{ fontWeight: "600", color: "red" }}>
                          {error.location}
                        </span>
                      )}
                    </div>
                  </>
                )}

              {((currentUserData.roleName === "Manager" && selectedRole) ||
                (selectedRole && selectedLocation)) &&
                selectedRole !== "Manager" && (
                  <>
                    <div style={{ marginBottom: error.location ? 0 : 0 }}>
                      <Select
                        size="large"
                        style={{ minWidth: "100%" }}
                        placeholder="Select Plant*"
                        value={selectedPlant}
                        onChange={handlePlantChange}
                        error={error.plant}
                      >
                        {plants.map(({ id, plant_name }) => (
                          <Select.Option key={id} value={id}>
                            {plant_name}
                          </Select.Option>
                        ))}
                      </Select>
                      {error.plant && (
                        <span style={{ fontWeight: "600", color: "red" }}>
                          {error.plant}
                        </span>
                      )}
                    </div>
                  </>
                )}
            </div>
            <div
              className=""
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "1rem",
              }}
            >
              <Button
                className="commButton"
                type="primary"
                style={{ width: "20%", padding: "0" }}
                danger
                onClick={() => handlePost()}
              >
                Submit
              </Button>
            </div>
          </>
      
      </Modal>

    </>
  );
};

export default Settings;
